import ThemeTopLayout from "gatsby-theme-material-ui-top-layout/src/components/top-layout";
import React from "react";


export default function TopLayout({ children, theme }) {

  return (
    <ThemeTopLayout theme={theme}>{children}</ThemeTopLayout>
  );
}